import React, {useState, useEffect} from "react"
import Row from "@amzn/meridian/row"
import ModalExample from "@amzn/meridian/modal";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Table, {TableRow, TableCell} from "@amzn/meridian/table";
import Column from "@amzn/meridian/column";
import Currency from "../../common/currency";
import {getRunningBalanceDetails} from "../../driverReconciliation/network/runningBalanceDetailsAPI"
import Button from "@amzn/meridian/button";
import {downloadRunningBalanceDetailsExcel} from "./runningBalanceDetailsExcelDownload";



const OverviewSection = (props) => {
    let {data, runningBalance} = props;

    return (<Box>
        <Column space="small">
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Driver Name</Text>
                {data.driverInfo.name}
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Employee Id</Text>
                {data.compEmployeeId}
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">DSP Name</Text>
                {data.providerInfo.name}
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Running Balance</Text>
                {runningBalance?<Currency amount={runningBalance} isVariance={true}/> : "NA"}
            </Row>

        </Column>
    </Box>);
}

const RunningBalanceDetailsSection = ({values}) => {

    return (
            <Table headerRows={1}>
                <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Cash Difference</TableCell>
                    <TableCell>Reason</TableCell>
                    <TableCell>TT Link</TableCell>
                </TableRow>

                {values.employeeDebriefDetailList && values.employeeDebriefDetailList.map(function (employeeDebriefDetail, index) {
                    const {cashDiff, cashDiffReason, issueLink, debriefDate} = employeeDebriefDetail;
                    return <TableRow key={index}>
                        <TableCell>{debriefDate}</TableCell>
                        <TableCell>{cashDiff?<Currency amount={cashDiff} isVariance={true}/> : "NA"}</TableCell>
                        <TableCell>{cashDiffReason}</TableCell>
                        <TableCell>{issueLink}</TableCell>

                    </TableRow>
                })}
            </Table>
    );
}

const ErrorMessageSection = ({values}) => {
    if (values.length) {
        return (
            <Box spacingInset="small none">
                <Row>
                    <Text color="secondary" >{values}</Text>
                </Row>
            </Box>

        );
    }
    else return null;
}

const RunningBalanceDetailsDownloadExcelSection = ({values}) => {
    console.log(values)
    return (
        <div>
            <div>
                <Button size="small" onClick={() => downloadRunningBalanceDetailsExcel(values)}
                        disabled={!values.employeeDebriefDetailList
                        || (values.employeeDebriefDetailList && values.employeeDebriefDetailList.length === 0)}>
                    Download
                </Button>
            </div>
        </div>
    );
}

const RunningBalanceModal = (props) => {
    const { onClose, runningBalanceModalData, value} = props;
    const [runningBalanceDetailsAPIResponse, setRunningBalanceDetailsAPIResponse] = useState({});
    const [errorMessage, setErrorMessage] = useState({});

    useEffect(() => {
        if (Object.keys(runningBalanceModalData).length && value) {
            setRunningBalanceDetailsAPIResponse([])
            setErrorMessage({})
            getRunningBalanceDetails(runningBalanceModalData)
                .then(result => {
                    if (result.hasError) {
                        setErrorMessage(result.errorMessage)
                    }
                    else {
                        setRunningBalanceDetailsAPIResponse(result)
                        console.log("runningBalanceDetailsAPIResponse: " + runningBalanceDetailsAPIResponse);
                    }
                })

        }
    },[runningBalanceModalData]);

    return (
        <React.Fragment>
            <ModalExample title="Running Balance Details" open={props.value} scrollContainer="viewport"
                          closeLabel="Close" onClose={onClose}>

                {
                    <OverviewSection data={runningBalanceModalData} runningBalance={runningBalanceDetailsAPIResponse.runningBalance || []}/>
                }

                <br/>
                <br/>

                {
                    <RunningBalanceDetailsSection values={runningBalanceDetailsAPIResponse} />
                }

                <br/>
                <br/>
                <br/>

                {
                    <ErrorMessageSection values={errorMessage} />
                }

                <br/>

                {
                    <RunningBalanceDetailsDownloadExcelSection values={runningBalanceDetailsAPIResponse} />
                }


            </ModalExample>

        </React.Fragment>
    )
}

export default RunningBalanceModal


// WEBPACK FOOTER //
// ./src/component/modal/driverReconciliation/runningBalanceModal.js